<template>
  <div class="global-contact-form-wrapper">
    <div class="contact-form-container">
      <div class="form-content">
        <div class="form-header">
          <h2 class="form-title">{{ $t('globalContactForm.title') }}</h2>
          <p class="form-subtitle">{{ $t('globalContactForm.subtitle') }}</p>
        </div>

        <el-form ref="globalContactForm"
                 :model="formData"
                 :rules="rules"
                 label-position="top"
                 class="contact-form">
          <div class="form-row">
            <el-form-item :label="$t('globalContactForm.fields.name')"
                          prop="name"
                          class="form-item">
              <el-input v-model="formData.name"
                        :placeholder="$t('globalContactForm.placeholders.name')" />
            </el-form-item>
            <el-form-item :label="$t('globalContactForm.fields.email')"
                          prop="email"
                          class="form-item">
              <el-input v-model="formData.email"
                        :placeholder="$t('globalContactForm.placeholders.email')" />
            </el-form-item>
          </div>

          <div class="form-row">
            <el-form-item :label="$t('globalContactForm.fields.phone')"
                          prop="phone"
                          class="form-item">
              <el-input v-model="formData.phone"
                        :placeholder="$t('globalContactForm.placeholders.phone')" />
            </el-form-item>
            <el-form-item :label="$t('globalContactForm.fields.company')"
                          prop="company"
                          class="form-item">
              <el-input v-model="formData.company"
                        :placeholder="$t('globalContactForm.placeholders.company')" />
            </el-form-item>
          </div>

          <el-form-item :label="$t('globalContactForm.fields.message')"
                        prop="message"
                        class="form-item full-width">
            <el-input type="textarea"
                      v-model="formData.message"
                      :rows="4"
                      :placeholder="$t('globalContactForm.placeholders.message')" />
          </el-form-item>

          <div class="form-actions">
            <el-button type="primary"
                       class="submit-btn"
                       @click="submitForm"
                       :loading="isSubmitting"
                       :disabled="isSubmitting">
              {{ isSubmitting ? $t('globalContactForm.submitting') : $t('globalContactForm.submit') }}
            </el-button>
          </div>
        </el-form>
      </div>

      <div class="form-visual">
        <div class="visual-content">
          <div class="icon-wrapper">

          </div>
          <h3 class="visual-title">{{ $t('globalContactForm.visual.title') }}</h3>
          <p class="visual-text">{{ $t('globalContactForm.visual.description') }}</p>

          <div class="contact-info">
            <div class="contact-item">
              <span class="contact-label">{{ $t('globalContactForm.contact.phone') }}</span>
              <span class="contact-value">+86 183 7927 6683</span>

            </div>
            <div class="contact-item">
              <span class="contact-label">{{ $t('globalContactForm.contact.email') }}</span>
              <span class="contact-value">sam@zz-steam.com</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { contactApi } from '@/api'

export default {
  name: 'GlobalContactForm',
  data() {
    return {
      formData: {
        name: '',
        email: '',
        phone: '',
        company: '',
        message: '',
        country: 'China',
        state: 1
      },
      rules: {
        name: [
          { required: true, message: this.$t('globalContactForm.validation.name'), trigger: 'blur' }
        ],
        email: [
          { required: true, message: this.$t('globalContactForm.validation.email'), trigger: 'blur' },
          { type: 'email', message: this.$t('globalContactForm.validation.emailFormat'), trigger: 'blur' }
        ],
        phone: [
          { required: true, message: this.$t('globalContactForm.validation.phone'), trigger: 'blur' },
          { validator: this.validatePhone, trigger: 'blur' }
        ],
        message: [
          { required: true, message: this.$t('globalContactForm.validation.message'), trigger: 'blur' }
        ]
      },
      isSubmitting: false
    }
  },
  methods: {
    async submitForm() {
      try {
        const valid = await this.$refs.globalContactForm.validate();
        if (!valid) return;

        this.isSubmitting = true;

        const formData = {
          name: this.formData.name,
          phone: this.formData.phone,
          email: this.formData.email,
          message: this.formData.message,
          corporateName: this.formData.company,
        };

        await contactApi.submitMessage(formData);

        this.$message.success(this.$t('globalContactForm.success'));
        this.resetForm();
      } catch (error) {
        console.error('提交请求失败:', error);
        this.$message.error(this.$t('globalContactForm.networkError'));
      } finally {
        this.isSubmitting = false;
      }
    },
    resetForm() {
      this.$refs.globalContactForm.resetFields();
      this.formData = {
        name: '',
        email: '',
        phone: '',
        company: '',
        message: '',
        country: 'China',
        state: 1
      };
    },
    // 验证电话号码格式
    validatePhone(rule, value, callback) {
      if (!value) {
        callback();
        return;
      }

      // 移除所有空格和特殊字符，只保留数字、+、-、(、)
      const cleanPhone = value.replace(/[\s\-()]/g, '');

      // 中国手机号格式：+86 或 86 开头，后面跟11位数字
      const chinaMobileRegex = /^(\+?86)?1[3-9]\d{9}$/;

      // 国际电话号码格式：+开头，后面跟1-15位数字
      const internationalRegex = /^\+[1-9]\d{1,14}$/;

      // 普通电话号码格式：7-15位数字
      const generalPhoneRegex = /^\d{7,15}$/;

      if (chinaMobileRegex.test(cleanPhone) ||
        internationalRegex.test(cleanPhone) ||
        generalPhoneRegex.test(cleanPhone)) {
        callback();
      } else {
        callback(new Error(this.$t('globalContactForm.validation.phoneFormat')));
      }
    }
  }
}
</script>

<style scoped>
.global-contact-form-wrapper {
  width: 100%;
  background: #f2f2f2;
  padding: 60px 0;
  margin-top: -50px;
}

.contact-form-container {
  max-width: 1000px;
  margin: 0 auto;
  padding: 0 20px;
  display: grid;
  grid-template-columns: 1fr 350px;
  gap: 50px;
  align-items: stretch;
}

.form-content {
  padding: 30px;
  border-radius: 16px;
  /* box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08); */
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.form-header {
  text-align: center;
  margin-bottom: 25px;
}

.form-title {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin-bottom: 6px;
  font-family: var(--font-primary);
}

.form-subtitle {
  font-size: 18px;
  color: #666;
  line-height: 1.5;
  margin: 0;
}

.contact-form {
  width: 100%;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 16px;
}

.form-item {
  margin-bottom: 0;
}

.full-width {
  grid-column: 1 / -1;
}

.contact-form :deep(.el-form-item__label) {
  color: #333;
  font-weight: 500;
  padding-bottom: 8px;
  line-height: 1;
  font-family: var(--font-secondary);
}

.contact-form :deep(.el-input__inner) {
  height: 40px;
  line-height: 40px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  padding: 0 12px;
  transition: all 0.3s ease;
  font-family: var(--font-secondary);
}

.contact-form :deep(.el-input__inner:focus) {
  border: 1px solid #2ea2fa !important;
  box-shadow: none !important;
}

.contact-form :deep(.el-textarea__inner) {
  border: 2px solid #e9ecef;
  border-radius: 8px;
  padding: 12px;
  transition: all 0.3s ease;
  font-family: var(--font-secondary);
  resize: vertical;
}

.contact-form :deep(.el-textarea__inner:focus) {
  border: 1px solid #2ea2fa !important;
  box-shadow: none !important;
}

.form-actions {
  text-align: left;
  margin-top: 25px;
}

.submit-btn {
  width: 180px;
  height: 45px;
  background: #2ea2fa;
  border: none;
  border-radius: 22px;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  transition: all 0.3s ease;
  font-family: var(--font-primary);
}

.submit-btn:hover {
  transform: translateY(-2px);
}

.submit-btn:active {
  transform: translateY(0);
}

.form-visual {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 30px;
  /* background: #fff; */
  border-radius: 16px;
  height: 100%;
  margin-top: -37%;
}

.visual-content {
  text-align: center;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  min-height: 350px;
}

.icon-wrapper {
  margin-bottom: 16px;
  display: flex;
  justify-content: center;
  flex: 1;
  align-items: center;
}

.visual-title {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin-bottom: 15px;
  font-family: var(--font-primary);
}

.visual-text {
  font-size: 18px;
  color: #666;
  line-height: 1.6;
  margin-top: -25px;
  margin-bottom: 25px;
  flex: 1;
  display: flex;
  align-items: center;
}

.contact-info {
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1;
  justify-content: flex-end;
}

.contact-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px;
  background: #ffffff;
  border-radius: 8px;
  border-left: 10px solid #2ea2fa;
}

.contact-label {
  font-size: 18px;
  color: #333;
  font-weight: 400;
}

.contact-value {
  font-size: 18px;
  color: #333;
  font-weight: 400;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .contact-form-container {
    grid-template-columns: 1fr;
    gap: 35px;
    max-width: 700px;
    align-items: start;
  }

  .form-visual {
    order: -1;
    padding: 18px;
    height: auto;
  }

  .visual-content {
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 25px;
    text-align: left;
    align-items: center;
    min-height: auto;
    height: auto;
  }

  .icon-wrapper {
    margin-bottom: 0;
    flex: none;
  }

  .visual-text {
    flex: none;
  }

  .contact-info {
    grid-column: 1 / -1;
    flex-direction: row;
    gap: 18px;
    flex: none;
  }
}

@media (max-width: 768px) {
  .global-contact-form-wrapper {
    padding: 35px 0;
  }

  .contact-form-container {
    padding: 0 15px;
    gap: 25px;
    align-items: start;
  }

  .form-content {
    padding: 25px 18px;
  }

  .form-title {
    font-size: 22px;
  }

  .form-row {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .visual-content {
    grid-template-columns: 1fr;
    text-align: center;
    gap: 18px;
    min-height: auto;
    height: auto;
  }

  .contact-info {
    flex-direction: column;
    gap: 12px;
  }

  .submit-btn {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .form-content {
    padding: 18px 12px;
  }

  .form-title {
    font-size: 20px;
  }

  .form-subtitle {
    font-size: 13px;
  }
}
</style> 
